export const reportData = [
  { label: "Fake Profile", value: 10, color: "#ef4444" },
  { label: "Not a Match for Me", value: 9, color: "#34d399" },
  { label: "Underage User", value: 9, color: "#ec4899" },
  { label: "Harassment", value: 8, color: "#3b82f6" },
  { label: "Spam", value: 6, color: "#f59e0b" },
  { label: "Creepy or Uncomfortable", value: 4, color: "#c0ca33" },
  { label: "Ask Money", value: 3, color: "#5bc0be" },
  { label: "Inappropriate", value: 1, color: "#8b5cf6" },
];
